import React, { useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";

// core components
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import {
  Box,
  Grid,
  Card as MUICard,
  CardMedia,
  CardActions,
  Button as MUIButton,
  Typography,
} from "@mui/material";

import styles from "../../../assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";

import {
  CLEAR_ERROR,
  DELETE_FACE_PHOTO_REQUESTED,
  GET_FACE_PHOTO_REQUESTED,
} from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import history from "../../../history";

import PropTypes from "prop-types";
import ConfirmationAlert from "components/Alert/ConfirmationAlert.js";

const useStyles = makeStyles(styles);

export default function FaceGallery(props) {
  const currentUser = useSelector((state) => state.login.loginUser.detail);

  const [userId, setUserId] = React.useState(false);
  const [validationErrMsg, setValidationErrMsg] = React.useState(null);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [user, setUser] = React.useState({});
  const [alert, setAlert] = React.useState(null);

  const dispatch = useDispatch();

  const userFaces = useSelector((state) => state.face.facePhoto);
  const photoDeleteSuccess = useSelector(
    (state) => state.face.facePhotoDeleteSuccess
  );

  const photoDeleteError = useSelector(
    (state) => state.face.facePhotoDeleteError
  );

  useEffect(() => {
    if (currentUser)
      dispatch({
        payload: { id: currentUser.id },
        type: GET_FACE_PHOTO_REQUESTED,
      });
  }, [currentUser]);

  useEffect(() => {
    if (photoDeleteSuccess) {
      dispatch({
        payload: { id: currentUser.id },
        type: GET_FACE_PHOTO_REQUESTED,
      });
    }
  }, [photoDeleteSuccess]);

  function clearErrors() {
    setValidationErrMsg("");
  }

  useEffect(() => {
    setModalOpen(props.open);
  }, [props.open]);

  useEffect(() => {
    if (!modalOpen) {
      clearErrors();
      // setUser({});
    }
  }, [modalOpen]);

  useEffect(() => {
    setValidationErrMsg("");
    dispatch({ type: CLEAR_ERROR });
  }, []);

  useEffect(() => {
    setUser(props.user);
    setUserId(props.user.id);
  }, [props.user]);

  function handleDelete(id) {
    dispatch({ payload: { id }, type: DELETE_FACE_PHOTO_REQUESTED });
  }
  const hideAlert = () => {
    setAlert(null);
  };

  return (
    <div>
      <Grid container spacing={2}>
        {userFaces?.matcher?.facePhotos?.map((face) => (
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardMedia
                component="img"
                height="200"
                image={face?.photoURL}
                alt={`Image`}
              />
              <CardActions>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() =>
                    setAlert(
                      <ConfirmationAlert
                        cancel={hideAlert}
                        submit={() => handleDelete(face?.id)}
                        message={"You are deleting photo"}
                        style={{
                          display: "block",
                        }}
                      />
                    )
                  }
                >
                  Delete
                </Button>
                {alert}

                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => history.push("/admin/face-upload")}
                >
                  Replace
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

FaceGallery.propTypes = {
  user: PropTypes.object,
};
